import React, { Component } from "react";
import "./OtpInput.css";

export default class OtpInput extends Component {
  constructor(props) {
    super(props);
    this.setOtp = this.props.onChange;
    this.inputsRef = [];
  }

  handleKeyDown(e, i) {
    const { numInputs,onEnterPress } = this.props;

    const preI = i - 1;
    const nextI = i + 1;

    const pressedKey = e.key;

    switch (pressedKey) {
      case 'Backspace':
      case 'Delete': {
        e.preventDefault();
        this.inputsRef[i].value = '';
        this.setOtp(e,i);
        if(preI >= 0) 
          this.inputsRef[preI].select();
        break;
      }
      case 'ArrowLeft': {
        e.preventDefault();
        if(preI >= 0) 
          this.inputsRef[preI].select();
          break;
      }
      case 'ArrowRight': {
        e.preventDefault();
        if(nextI < numInputs) 
          this.inputsRef[nextI].select();
          break;
      }
      case 'Enter':{
        e.preventDefault();
        if(typeof onEnterPress !== 'undefined')
          onEnterPress();
        break;
      }
      default: {
        // Ignore all special keys if it is not numeric or alphabet characters
        if (pressedKey.match(/^[^a-zA-Z0-9]$/)) {
          e.preventDefault();
        }
        break;
      }
    }
  }

  handlePaste(e,i){
    const { numInputs } = this.props;
    e.preventDefault();
    const pasteData = e.clipboardData.getData('text');

    this.inputsRef[pasteData.length-1 < numInputs ?  pasteData.length-1 : numInputs-1].focus();
    setTimeout(()=>{
      this.inputsRef[pasteData.length-1 < numInputs ?  pasteData.length-1 : numInputs-1].select();
    },50);

    this.setOtp(e,i);
  }

  handleChange(e,i){
    const { numInputs } = this.props;
    const preI = i - 1;
    const nextI = i + 1;
    this.setOtp(e,i);
    if(e.target.value.length == 1){
      this.inputsRef[nextI < numInputs ?  nextI : numInputs-1].focus();
      this.inputsRef[nextI < numInputs - 1 ? nextI : numInputs - 1].select();
    }else{
      if(preI >= 0) 
       this.inputsRef[preI].select();
    }

  }

  handleInput(e,i){
    const { numInputs } = this.props;
    const nextI = i + 1;
    this.setOtp(e,i);
    this.inputsRef[nextI < numInputs ?  nextI : numInputs-1].focus();
    this.inputsRef[nextI < numInputs - 1 ? nextI : numInputs - 1].select();
  }



  renderInputs() {
    const {value, numInputs} = this.props;
    const inputs = [];
    for (let i = 0; i < numInputs; i++) {
      inputs.push(
        <input
          ref={ref=>this.inputsRef.push(ref)}
          id={`input-otp-${i}`}
          key={i}
          autoComplete="off"
          maxLength={1}
          aria-label={`Please enter OTP character ${i+1}`}
          class="otp-input-key"
          type="text"
          inputMode="text"
          onFocus={e=> e.target.select()}
          onKeyDown={e => this.handleKeyDown(e, i)}
          onChange={e=>this.handleChange(e,i)}
          onPaste={e=>this.handlePaste(e,i)}
          value={value[i] || ''}
        />
      );
    }

    return inputs;
  }

  render() {
    const {style} = this.props;

    return (
      <div className="otp-input-container" style={style}>
          {this.renderInputs()}
      </div>
    );
  }
}
